<script>
import axios from '@/utils/axios';
// import { getBranches } from '@/utils/branch';
// import { allUsers, userById } from '@/utils/user';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore'

export default {
  inject: ['setLoading'],
  data() {
    return {
      loading: true,
      title: "Main Menu",
      text: "Main Menu",
      role_id: '',
      status: '',
      // users: [],
      user: '',
      parent_id: '',
      branch_id: '',
      // branches: [],
      search_keyword: '',
      // data: [],
      roles: [],
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
      },
    };
  },

  // computed: {
  //  text1(){
  //   return `Users (${this.pagination.total})`;
  //  }, 
  //  serialNo(){
  //   return (this.pagination.current_page - 1) * this.pagination.per_page;
  //  } 
  // },

  computed: {
 users() {
  return useLeadMetaStore().users || [];
 },
 branches() {
  return useLeadMetaStore().branches || [];
 },
 text1(){
  return `Users (${this.pagination.total})`;
 }, 
 serialNo(){
  return (this.pagination.current_page - 1) * this.pagination.per_page;
 } 
},

  // mounted(){
  //  this.getRoles();
  //  this.allUsers();  
  //  this.subadmins();
  //  this.allBranches();
  // }, 

  mounted(){
  this.getRoles();
  this.loadMeta();
  this.subadmins();
  },

  methods: {
    
    // async allUsers(){
    //  const response = await allUsers();
    //  this.users = response.data.data;
    // },

    // async allBranches(){
    //  this.branches = await getBranches();
    // },

    async loadMeta(){
      await useLeadMetaStore().loadAll()
    },

    async onUserUpdated(){
      await useLeadMetaStore().refreshUsers()
      this.subadmins()
    },

    async getRoles(){
    //  this.setLoading(true);
     try{
      const response = await axios.get('/roles');
      this.roles = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      // this.setLoading(false);
     }
    },

    async subadmins(page = 1) {
      this.loading = true; 
      
    //  this.setLoading(true);
     try{
      const params = {
       page,
       status: this.status || '',
       role_id: this.role_id || '',
       branch_id: this.branch_id || '',
       parent_id: this.parent_id || '', 
       search_keyword: this.search_keyword.trim() || '' 
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/users?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.loading = false; 
      // this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.subadmins(page);
    },

   async updateStatus(row){
    //this.setLoading(true);
    try{
     await axios.patch(`/users/${row.id}/status`, {
      status: row.status
     });
    }catch(error){
     row.status = !row.status; 
     this.$swalToast(error.message, 'error');
    }finally{
     //this.setLoading(false); 
    }
   },

   clearFilter(){
    this.role_id = '';
    this.status = '';
    this.branch_id = '';
    this.parent_id = '';
    this.search_keyword = '';
    this.subadmins();
   },

   async exportFile(){
    this.setLoading(true);
    try{
     const response = await axios.get('/users/export/excel', {
      responseType: 'blob'
     });
     const blob = new Blob([response.data], { type: response.headers['content-type'] });
     // Create a link element
     const link = document.createElement('a');
     link.href = URL.createObjectURL(blob);
     // Extract filename from Content-Disposition header if available
     let filename = 'users_export.xlsx';  // fallback default
     const disposition = response.headers['content-disposition'];
     if(disposition && disposition.indexOf('filename=') !== -1){
      const filenameMatch = disposition.match(/filename="?(.+)"?/);
      if (filenameMatch.length === 2) filename = filenameMatch[1];
     }
     link.download = filename;
     // Append to body and trigger click to download
     document.body.appendChild(link);
     link.click();
     // Cleanup
     document.body.removeChild(link);
     URL.revokeObjectURL(link.href);
    }catch(error){
     console.log(error.message);
    }finally{
     this.setLoading(false); 
    }
   }
    
  },
};
</script>

<style scoped>
/* ── USER AVATAR ── */
.u-avatar {
  width: 34px; height: 34px; border-radius: 50%;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 700; color: #fff;
  flex-shrink: 0;
}
 
/* ── TABLE STYLES ── */
.u-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 6px;
}
 
.u-table thead tr th {
  font-size: 10.5px; font-weight: 700; color: #000;
  text-transform: uppercase; letter-spacing: .6px;
  background: transparent; padding: 14px 14px 14px;
  border: none; white-space: nowrap;
  background-color: #fff;
}
 .u-table thead tr th:first-child {
    border-radius: 10px 0 0 10px;
}
.u-table thead tr th:last-child {
    border-radius: 0 10px 10px 0;
}
.u-table tbody tr td {
  padding: 13px 14px; font-size: 12.5px;
  color: #1e293b; vertical-align: middle;
  background: #fff;
  transition: box-shadow .15s, border-color .15s;
}
.u-table tbody tr td:first-child {
  border-left: 1px solid #e8edf3;
  border-radius: 10px 0 0 10px;
}
.u-table tbody tr td:last-child {
  border-right: 1px solid #e8edf3;
  border-radius: 0 10px 10px 0;
}
.u-table tbody tr:hover td {
  border-color: #c7d2fe;
}
 
/* ── NAME / META TEXT ── */
.u-name { font-size: 13px; font-weight: 600; color: #0f172a; }
.u-branch-badge {
  display: inline-block; font-size: 10px; color: #6366f1;
  background: #eef2ff; border: 1px solid #c7d2fe;
  border-radius: 20px; padding: 1px 8px; margin-top: 3px;
}
.u-meta {
  font-size: 12px; color: #000;
  display: flex; align-items: center; gap: 5px;
}
.u-meta i { font-size: 13px; flex-shrink: 0; }
.u-parent-badge {
  font-size: 11px; color: #475569;
  background: #f1f5f9; border: 1px solid #e2e8f0;
  border-radius: 20px; padding: 2px 10px; display: inline-block;
}
.u-role-text { font-size: 12px; color: #1e293b; font-weight: 500; }
 
/* ── FILTER BAR ── */
.u-filter-bar {
  display: flex; align-items: center; flex-wrap: wrap; gap: 8px;
}
.u-filter-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none; cursor: pointer;
  transition: border-color .15s;
  min-width: 120px;
}
.u-filter-select:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
.u-search-wrap {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  overflow: hidden; background: #fff;
  transition: border-color .15s;
}
.u-search-wrap:focus-within { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
.u-search-input {
  border: none; outline: none; height: 34px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  width: 200px; background: transparent;
}
.u-search-btn {
  width: 36px; height: 36px; background: #0f172a;
  border: none; color: #fff; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; flex-shrink: 0;
  transition: background .15s;
}
.u-search-btn:hover { background: #1e293b; }
.u-clear-btn {
  width: 34px; height: 34px; background: #fff0f3;
  border: 1.5px solid #fecdd3; border-radius: 8px;
  color: #f43f5e; font-size: 15px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.u-clear-btn:hover { background: #f43f5e; color: #fff; border-color: #f43f5e; }
 
/* vue-select in filter */
:deep(.u-vselect .vs__dropdown-toggle) {
  border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important;
  min-height: 36px !important; padding: 0 8px !important;
  background: #fff !important;
}
:deep(.u-vselect .vs__dropdown-toggle:focus-within) {
  border-color: #6366f1 !important;
  box-shadow: 0 0 0 3px rgba(99,102,241,.1) !important;
}
:deep(.u-vselect .vs__search) { font-size: 12.5px !important; min-width: 100px; }
:deep(.u-vselect .vs__selected) {
  font-size: 12px !important; background: #eef2ff !important;
  border: 1px solid #c7d2fe !important; border-radius: 5px !important;
  color: #3730a3 !important;
}
</style>
 
<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
 
<div class="page-wrapper">
  <div class="content">
 
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
 
        <!-- Export -->
        <div v-if="pagination.total">
          <div class="dropdown">
            <a href="javascript:void(0);"
              class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="dropdown">
              <i class="ti ti-file-export me-1"></i>Export
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile">
                  <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                </a>
              </li>
            </ul>
          </div>
        </div>
 
        <!-- Add User -->
        <a href="javascript:void(0);"
          data-bs-toggle="modal" data-bs-target="#admin_modal"
          class="btn btn-primary d-flex align-items-center"
          @click="$refs.subadminModal.add();">
          <i class="ti ti-circle-plus me-2"></i>Add User
        </a>
 
      </div>
    </div>
    <!-- /Breadcrumb -->
 
    <!-- Main Card -->
    <div class="card border-0 shadow-sm" style="border-radius:14px; overflow:hidden;">
 
      <!-- Card Header — title + filters -->
      <div class="card-header bg-white border-bottom d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
        <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
          Users List
          <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{ pagination.total }})</span>
        </h5>
 
        <!-- Filters -->
        <div class="u-filter-bar">
 
          <!-- Clear filter -->
          <button
            v-if="search_keyword !== '' || status !== '' || role_id !== '' || branch_id !== '' || parent_id !== ''"
            class="u-clear-btn" @click="clearFilter()" title="Clear filters">
            <i class="ti ti-filter-x"></i>
          </button>
 
          <!-- Branch (admin only) -->
          <select class="u-filter-select" v-model="branch_id" @change="subadmins" v-if="auth?.type === 'ADMIN'" style="min-width:130px;">
            <option value="">Branches</option>
            <option :value="row.id" v-for="row in branches" :key="row.id">{{ row.name }}</option>
          </select>
 
          <!-- Parent User (admin only) -->
          <div v-if="auth?.type === 'ADMIN'" style="min-width:160px;">
            <vue-select
              class="u-vselect"
              :options="users" label="name"
              v-model="parent_id"
              placeholder="Parent User"
              :reduce="u => u.id"
              @update:modelValue="subadmins()"
            />
          </div>
 
          <!-- Status -->
          <select class="u-filter-select" v-model="status" @change="subadmins">
            <option value="">Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
 
          <!-- Role -->
          <select class="u-filter-select" v-model="role_id" @change="subadmins">
            <option value="">Role</option>
            <option :value="row.id" v-for="row in roles" :key="row.id">{{ row.name }}</option>
          </select>
 
          <!-- Search + Button -->
          <div class="u-search-wrap">
            <input
              type="text" class="u-search-input"
              v-model="search_keyword"
              placeholder="Search..."
              @keyup.enter="subadmins()"
            />
            <button class="u-search-btn" type="button" @click="subadmins()">
              <i class="ti ti-search"></i>
            </button>
          </div>
 
        </div>
      </div>
 
      <!-- Card Body -->
      <div class="card-body px-3 pt-2 pb-3" style="background:#f1f5f9;">
          <!-- Skeleton -->
  <app-skeleton v-if="loading" type="table" :rows="5" :columns="8" />

        <div class="table-responsive" v-else-if="data.length">
          <table class="u-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Parent</th>
                <th>Role</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in data" :key="row.id">
 
                <td style="color:#94a3b8; font-size:11px; font-weight:600; width:42px;">
                  {{ serialNo + index + 1 }}.
                </td>
 
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="u-avatar"
                      :style="{ background: `hsl(${((row.name || 'A').charCodeAt(0) * 37) % 360}, 60%, 55%)` }">
                      {{ (row.name || '').charAt(0).toUpperCase() }}
                    </div>
                    <div>
                      <div class="u-name">{{ row.name }}</div>
                      <div v-if="row?.branch !== null">
                        <span class="u-branch-badge">
                          {{ row?.branch?.name }}<span v-if="row?.branch?.code"> ({{ row?.branch?.code }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
 
                <td>
                  <span class="u-meta">
                    <i class="ti ti-mail" style="color:#22c55e;"></i>
                    {{ row.email }}
                  </span>
                </td>
 
                <td>
                  <span class="u-meta">
                    <i class="ti ti-phone" style="color:#6366f1;"></i>
                    {{ row.mobile }}
                  </span>
                </td>
 
                <td>
                  <span v-if="row?.parent" class="u-parent-badge">{{ row.parent.name }}</span>
                  <span v-else style="color:#cbd5e1;">—</span>
                </td>
 
                <td>
                  <span class="u-role-text">{{ row.role?.name || '—' }}</span>
                </td>
 
                <td>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" v-model="row.status" @change="updateStatus(row)" />
                  </div>
                </td>
 
                <td>
                  <div class="dropdown">
                    <button class="btn btn-icon btn-sm rounded-circle" type="button"
                      data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="ti ti-dots-vertical"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <a class="dropdown-item rounded-1" href="javascript:void(0);"
                          data-bs-toggle="modal" data-bs-target="#admin_modal"
                          @click="$refs.subadminModal.editAdmin(row)">
                          <i class="ti ti-edit me-1"></i>Edit
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item rounded-1" href="javascript:void(0);"
                          data-bs-toggle="modal" data-bs-target="#delete_modal"
                          @click="$refs.subadminModal.editAdmin(row)">
                          <i class="ti ti-trash me-1"></i>Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
 
              </tr>
            </tbody>
          </table>
        </div>
 
        <div v-else style="text-align:center; padding:48px; color:#94a3b8;">
          <i class="ti ti-users" style="font-size:36px; display:block; margin-bottom:10px; opacity:.35;"></i>
          No users found.
        </div>
 
        <nav v-if="pagination.links.length > 3" class="px-4 py-3">
          <ul class="pagination pagination-sm mb-0">
            <li v-for="(link, index) in pagination.links" :key="index"
              :class="['page-item', { active: link.active, disabled: !link.url }]">
              <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
            </li>
          </ul>
        </nav>
 
      </div>
    </div>
    <!-- /Main Card -->
 
  </div>
 
  <app-footer></app-footer>
</div>
<!-- /Page Wrapper -->
 
<!-- <subadmin-modal :roles="roles" ref="subadminModal" @updated="subadmins"></subadmin-modal> -->

 <subadmin-modal :roles="roles" ref="subadminModal" @updated="onUserUpdated"></subadmin-modal>
</template>